/** Paramètres catalogue société — cases (stock, lignes). Fiches = menu Catalogue. */
export type CompanyProductSettings = {
  pr_inventory: boolean;
  pr_stock_mail: boolean;
  pr_stock_threshold: number;
  pr_show_discount: boolean;
  pr_show_cost: boolean;
  pr_show_qty: boolean;
  pr_default_qty: number;
  pr_autofill: boolean;
  pr_sync_from_invoice: boolean;
};

function asBool(v: unknown, fallback: boolean): boolean {
  if (v == null) return fallback;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (v === "0" || v === "false") return false;
  return Boolean(v);
}

function asInt(v: unknown, fallback: number, min: number, max: number): number {
  const n = Number(v);
  if (!Number.isFinite(n)) return fallback;
  const i = Math.trunc(n);
  if (i < min || i > max) return fallback;
  return i;
}

export function productSettingsFromCompany(
  row: Partial<CompanyProductSettings> | null | undefined
): CompanyProductSettings {
  return {
    pr_inventory: asBool(row?.pr_inventory, false),
    pr_stock_mail: asBool(row?.pr_stock_mail, false),
    pr_stock_threshold: asInt(row?.pr_stock_threshold, 0, 0, 999999),
    pr_show_discount: asBool(row?.pr_show_discount, false),
    pr_show_cost: asBool(row?.pr_show_cost, false),
    pr_show_qty: asBool(row?.pr_show_qty, true),
    pr_default_qty: asInt(row?.pr_default_qty, 1, 1, 9999),
    pr_autofill: asBool(row?.pr_autofill, true),
    pr_sync_from_invoice: asBool(row?.pr_sync_from_invoice, false),
  };
}
